import React from 'react';
import Dropdown from '../../../../Shared/Form/Dropdown/Dropdown';
import DatePicker from 'react-datepicker';
import TextInput from '../../../../Shared/Form/Inputs/TextInput';
import YearPicker from '../../YearPicker/YearPicker';

import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

var marginRightStyle = {
    margin: '0 10px 0 0'
};

export default class GeneralStep extends React.Component {
    constructor(props) {
        super(props);
      
        this.onDatepickerChange = this.onDatepickerChange.bind(this);
        this.updateHours = this.updateHours.bind(this);
        this.isWorkDay = this.isWorkDay.bind(this);
        this.onServiceTypeSelected = this.onServiceTypeSelected.bind(this);

        this.state = {
            hours: [],
            isOtherType: false,
            displayHours: '',
        };
    }

    componentDidMount() {
        this.updateHours(this.props.date);
       
    }
    componentDidUpdate(prevProps) {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        let isTomorrow = this.props.date && this.props.date.isSame(tomorrow, "day");
        let isToday = this.props.date && this.props.date.isSame(today, "day");
        if(isTomorrow) { 
            let hours = this.getHours(this.props.date);
            if(!hours || hours.length < 1) { 
                this.props.date = moment().utcOffset(0, true).add(2, 'days');
                this.forceUpdate();
            } else {
                if(!this.state.hours || this.state.hours.length < 1) { 
                    this.updateHours(this.props.date);
                }
            }
        } else if(isToday) { 
            let hours = this.getHours(this.props.date);
            if(!hours || hours.length < 1) { 
                this.props.date = moment().utcOffset(0, true).add(1, 'days');
                this.forceUpdate();
            }
        }
       
      }
    render() {
        let displayError = Object.keys(this.props.errors).length > 0 ? this.props.errors[Object.keys(this.props.errors)[0]] : '';

        let carMakes = this.getCarMakes();
        let selectedMake = this.props.appointment.make;

        let carModels = this.getCarModels(selectedMake);
        // opening hours for dealer 
        let displayHours = "";
        let relevant = this.props.sheduleTimes;
        displayHours = relevant.map(item => (<p>{item.stringFormat}</p>))

        this.state.displayHours = displayHours;
        return (
            <div className="generalStep">
                <p className="b-intro">
                    Please select a convenient time to leave your vehicle with us:
                </p>

                <p className="validation-errors">
                    {displayError}
                </p>
                <p className={this.state.displayHours != '' ? "opening-hours" : "opening-hours hidden"}>
                    <span className="title">Hours: </span>
                    {this.state.displayHours}
                </p>
                <DatePicker
                    selected={this.props.date}
                    onChange={this.onDatepickerChange}
                    dateFormat="dddd, MM/DD/YYYY"
                    minDate={moment()}
                    readOnly={true}
                    className="appointment-datepicker form-control"
                    calendarClassName="appointment-calendar"
                    filterDate={this.isWorkDay}
                    popperPlacement="botom-start"
                    popperModifiers={{
                        flip: {
                            enabled: false
                        },
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: false
                        }
                    }}
                />

                {
                    (this.props.appointmentDetails != '') &&
                    <p className="detail-info">
                        * {this.props.appointmentDetails}
                    </p>
                }

                <Dropdown
                    items={this.state.hours}
                    placeholder="Select Time"
                    name="hours"
                    styleClass="hoursUp"
                    onSelect={this.props.setAppointmentState}
                    isInvalid={this.props.errors['hours']}
                    selectedValue={this.props.appointment.hours}
                />

                <div className="line"></div>

                <p className="b-paragraph">
                    Please select the type of service(s) needed:
                </p>

              
                    <Dropdown
                        items={this.props.serviceTypes}
                        placeholder="Select Service Type"
                        name="serviceType"
                        onSelect={this.onServiceTypeSelected}
                        isInvalid={this.props.errors['serviceType']}
                        selectedValue={this.props.appointment.serviceType}
                    />
             
                {
                    this.state.isOtherType &&
                    
                    <TextInput
                        placeholder="Type here"
                        name="otherServiceType"
                        onChange={this.props.setAppointmentState}
                        value={this.props.appointment.otherServiceType}
                    />
                   
                }

                <Dropdown
                    items={carMakes}
                    placeholder="Car Make"
                    onSelect={this.props.setAppointmentState}
                    name="make"
                    
                    isInvalid={this.props.errors['make']}
                    selectedValue={this.props.appointment.make}
                />
               
                <div className="form-row">
                    <div style={marginRightStyle}>
                        <TextInput
                            placeholder="Car Model"
                            name="carModel"
                            onChange={this.props.setAppointmentState}
                            isInvalid={this.props.errors['name']}
                        />
                    </div>
                
                    <YearPicker
                        startDate={new Date(1950, 1)}
                        endDate={new Date((new Date().getFullYear() + 1), 1)}
                        onSelect={this.props.setAppointmentState}
                        selectedValue={this.props.appointment.CarYear}
                        styleClass="half"
                        placeholder="Year"
                        name="CarYear"
                        isInvalid={this.props.errors['carYear']}
                    />
                </div>
            </div>
        );
    }

    isWorkDay(date) {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        let isToday = date.isSame(today, "day");
        let isTomorrow = date.isSame(tomorrow, "day");
        let dayOfWeek = date.day();
        if((this.props.shouldDisableApptForToday || this.props.shouldDisableApptForNext24Hours) && isToday) {
            return false;
        }
        if(isToday || isTomorrow) {
            let hours = this.getHours(date);
            let isTodayEnabled = hours && hours.length > 0;
            // if(!isTomorrowEnabled) { 
            //     this.props.date = moment().utcOffset(0, true).add(2, 'days');
            // }
            return isTodayEnabled;
        }
        return this.props.sheduleTimes.find(x =>
            x.startDay <= dayOfWeek
            &&
            x.endDay >= dayOfWeek && x.isClosed !== true);
    }

    getCarMakes() {

        if (!this.props.cars) return [];

        return this.props.cars.map((car) => {
            return {
                value: car.makeId,
                label: car.label
            }
        });
    }

    getCarModels(makeId) {
        if (!makeId) return [];

        let selectedCar = this.props.cars.filter((car) => {
            return car.makeId === makeId;
        })[0];

        return selectedCar.models;
    }

    onServiceTypeSelected(e) {
        this.props.setAppointmentState(e);

        let serviceType = this.props.serviceTypes.find(x => x.value === this.props.appointment.serviceType);

        this.setState({ isOtherType: serviceType.label === 'Other' });

        

    }

    onDatepickerChange(date) {
        let eventArg = {
            target: {
                name: 'date',
                value: date
            }
        }
        this.props.setAppointmentState(eventArg);

        this.updateHours(date);
    }
    getHours(date) {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        let isToday = date.isSame(today, "day");
        let isTomorrow = date.isSame(tomorrow, "day");
        let hours = [];
        let dayOfWeek = date.day();//new Date(date).getDay();
        let period = this.props.sheduleTimes.find(x =>
            x.startDay <= dayOfWeek
            &&
            x.endDay >= dayOfWeek && x.isClosed !== true);
        if (period) {
            let sTime = period.startTime;
            let eTime = period.endTime;
            if( isToday || 
                (isTomorrow && this.props.shouldDisableApptForNext24Hours)){ 
                // disable time for tomorrow (24 h from now) 
                let hours = new Date().getHours();
                let minutes = new Date().getMinutes();
                if(minutes > 30) { 
                    minutes = '00';
                    hours = hours + 1;
                }
                if(minutes > 0 && minutes < 30) { 
                    minutes = '30';
                }
                sTime = hours + ':' + minutes + ':00';
            }
            hours = this.generateTimePeriod(sTime, eTime)
                .map(x => {
                    return {
                        label: moment.utc(x.asMilliseconds()).format("h:mm A "),
                        value: moment.utc(x.asMilliseconds()).format("HH:mm:ss")
                    };
                });
        }
        return hours;
    }
    updateHours(date) {
        let hours = this.getHours(date);
        this.setState({ hours });
    }

    generateTimePeriod(startTime, endTime) {
        const step = moment.duration(30, 'minutes');
        let period = [];
        let current = moment.duration(startTime);
        let endTimeValue = moment.duration(endTime);

        while (current.asMilliseconds() < endTimeValue.asMilliseconds()) {
            period.push(moment.duration(current));
            current.add(step);
        }
        return period;
    }
}


// WEBPACK FOOTER //
// ./Src/Appointment/AppointmentScheduler/AppointmentForm/Steps/GeneralStep.jsx